import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import { User } from "../../providers";

/**
 * Generated class for the RequestTermsAcceptedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-request-terms-accepted",
  templateUrl: "request-terms-accepted.html",
})
export class RequestTermsAcceptedPage {
  content: string;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public user: User
  ) {
    this.content = this.navParams.get("content");
  }

  accept() {
    let loading = this.loadingCtrl.create({
      spinner: "ios",
      dismissOnPageChange: true,
    });
    loading.present();
    this.user.update({ termsAcceptedAt: new Date() }).subscribe(
      (response: any) => {
        loading.dismiss();
        if (response.termsAcceptedAt) {
          this.viewCtrl.dismiss();
        } else {
          this.showError(
            "No hemos podido procesar la aceptación de los términos. Por favor, inténtalo de nuevo más tarde."
          );
        }
      },
      (err) => {
        console.log(err);
        loading.dismiss();
        this.showError(err.message);
      }
    );
  }

  showError(message) {
    let toast = this.toastCtrl.create({
      message: message,
      showCloseButton: true,
      closeButtonText: "Ok",
      position: "top",
      cssClass: "toast-danger",
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/request-terms-accepted/request-terms-accepted.ts